import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";

export default function Landing() {
  return (
    <div>
      <Navbar />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-7">
            <div className="font-mono text-xs uppercase tracking-widest text-[#555] mb-6">
              [ ISSUE 01 / DATING — RATED ]
            </div>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter">
              Faces<br />get scored.<br />
              <span className="text-[#E53935]">Matches</span> get<br />unlocked.
            </h1>
            <p className="mt-8 max-w-xl text-base text-[#333] leading-relaxed">
              FaceMatch is a brutally honest dating app. We score your photo with AI and the community,
              pair you with the people nearest to you, and let you unlock the ones who liked you back —
              for a flat <span className="font-mono font-bold">$10</span>.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <Link to="/signup" data-testid="cta-signup" className="px-6 py-4 bg-black text-white font-mono text-sm hover:bg-[#E53935] transition-colors">
                GET YOUR RATING →
              </Link>
              <Link to="/login" data-testid="cta-login" className="px-6 py-4 border border-black font-mono text-sm hover:bg-black hover:text-white transition-colors">
                I'M ALREADY IN
              </Link>
            </div>

            <div className="mt-14 grid grid-cols-3 gap-4 max-w-lg">
              {[
                { k: "01", t: "AI SCORE", d: "GPT-4o vision rates your photo 1.0 – 10.0" },
                { k: "02", t: "PROXIMITY", d: "Matches based on your real location" },
                { k: "03", t: "$10 UNLOCK", d: "Stripe or PayPal. See who liked you." },
              ].map(s => (
                <div key={s.k} className="border-l border-black pl-3">
                  <div className="font-mono text-xs text-[#555]">{s.k}</div>
                  <div className="font-display text-base mt-1">{s.t}</div>
                  <div className="text-xs text-[#555] mt-1 leading-snug">{s.d}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative">
              <div className="brutal brutal-shadow bg-white overflow-hidden">
                <img
                  alt="editorial portrait"
                  src="https://images.unsplash.com/photo-1533392151650-269f96231f65?crop=entropy&cs=srgb&fm=jpg&w=900&q=85"
                  className="w-full aspect-[4/5] object-cover grayscale"
                />
                <div className="p-4 border-t border-black flex items-center justify-between">
                  <div>
                    <div className="font-display text-xl">LENA, 27</div>
                    <div className="font-mono text-xs text-[#555]">BERLIN — 2.4 KM</div>
                  </div>
                  <div className="text-right">
                    <div className="font-mono text-[10px] text-[#555]">AI</div>
                    <div className="font-mono font-bold text-3xl text-[#E53935]">9.1</div>
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-6 -left-6 brutal bg-[#E53935] text-white px-4 py-2 font-mono text-xs rotate-[-2deg]">
                MUTUAL RATING ≥ 7 = MATCH
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="border-t border-black/10 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 sm:grid-cols-4 gap-6">
          {[
            ["RATE", "Swipe the deck. Tap a number 1–10."],
            ["GET RATED", "Others rate your photo. Avg updates live."],
            ["MATCH", "Mutual ≥ 7 unlocks a match card."],
            ["UNLOCK", "$10 → see contact, full profile, distance."],
          ].map(([t, d]) => (
            <div key={t} className="border-t border-black pt-4">
              <div className="font-display text-2xl tracking-tighter">{t}</div>
              <div className="text-sm text-[#555] mt-2">{d}</div>
            </div>
          ))}
        </div>
      </section>

      <footer className="border-t border-black/10 py-6 text-center font-mono text-xs text-[#555]">
        FACEMATCH © 2026 — AN EDITORIAL DATING EXPERIMENT
      </footer>
    </div>
  );
}
